module.exports = __webpack_public_path__ + "img/155.e7276a4f.svg";